import { register, findAll, find } from '../../../Javascript/Utils.js'
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
Swiper.use([Navigation, Pagination, Autoplay])

const SliderSwiper = el => {
  const swiperList = findAll('.swiper-container', el)
  const mySwiper = swiperList[swiperList.length - 1]
  const myNext = find('.swiper-button-next', el)
  const myPrev = find('.swiper-button-prev', el)
  const swiperWrapper = find('.swiper-wrapper', mySwiper)
  const autoPlay = document.querySelector('html').getAttribute('data-reduced-motion') ? false : !!el.dataset.autoplay
  const loop = !!el.dataset.loop

  const allSlides = swiperWrapper.children
  if (allSlides) {
    for (let i = 0; i < allSlides.length; i++) {
      allSlides[i].classList.add('slider-swiper-slide')
    }
  }

  const newSwiper = new Swiper(mySwiper, {
    modules: [Navigation, Pagination],
    slidesPerView: 'auto',
    spaceBetween: 24,
    slideClass: 'slider-swiper-slide',
    navigation: {
      addIcons: false,
      nextEl: myNext,
      prevEl: myPrev
    },
    on: {
      reachBeginning: function () {
        mySwiper.classList.remove('sliderSwiperLastSlide')
      },
      reachEnd: function () {
        mySwiper.classList.add('sliderSwiperLastSlide')
      }
    },
    autoplay: autoPlay,
    loop
  })
  return newSwiper
}
register('SliderSwiper', SliderSwiper)
